import { fetchWrapper, handleResponse, hcUrlV3, buildOpts } from 'services/RequestService/helpers';

const getPermissions = async () => {
  const response = await fetchWrapper(hcUrlV3('/abilities'), buildOpts());
  return handleResponse(response);
};

export { getPermissions };
